import { startOfDay } from 'date-fns';
import { TimelineItemBase } from 'react-calendar-timeline';
import { EmployeeWithPrioritiesDto, PriorityItemDto } from '../../api';
import { dateToUnix } from '../../utils/Utils';
import { groupParentId } from './TimelineUtils';

/**
 * Maps an employee to a root TimelineGroup and a nested TimelineGroup
 * @param employee employee
 * @returns TimelineGroup[] for an Employee
 */
export const employeeToTimelineGroups = (employee: EmployeeWithPrioritiesDto) => {
  return [
    {
      id: groupParentId(employee.id),
      title: `${employee.firstName} ${employee.lastName}`,
      rightTitle: `${employee.currentUtilisation}%`,
      currentUtilisation: employee.currentUtilisation,
      parent: groupParentId(employee.id),
      root: true,
    },
    {
      id: employee.id,
      parent: groupParentId(employee.id),
      title: `${employee.firstName} ${employee.lastName}`,
      root: false,
      currentUtilisation: employee.currentUtilisation,
    },
  ];
};

/**
 * Maps a priority to a TimelineItem
 * @param priority priority
 * @returns TimelineItemBase<number>
 */
export const priorityToTimelineItem = (priority: PriorityItemDto) => {
  return {
    id: priority.id,
    group: priority.employeeID,
    title: `${priority.utilisation}% - ${priority.project?.clientName} - ${priority.project?.name}`,
    start_time: dateToUnix(startOfDay(new Date(priority.startDate))),
    end_time: dateToUnix(startOfDay(new Date(priority.endDate))),
    priority: priority,
  } as TimelineItemBase<number>;
};

/**
 * Maps priority items to TimelineItems
 * @param priorities priorities
 * @returns TimelineItemBase<number>[]
 */
export const prioritiesToTimelineItems = (priorities: PriorityItemDto[]) => {
  return priorities.map(priorityToTimelineItem);
};
